module.exports = __webpack_public_path__ + "media/images/plans/plan-photo-3-50eccc2c00b7427edd5cb4701527bb5d.png";